//@ts-nocheck
"use client"
import { useEffect } from "react";

const HubSpotForm = ({ hubSpotCredentials }) => {
  const { portalId, formId, region = "na1" } = hubSpotCredentials;

  useEffect(() => {
    const loadScript = () => {
      if (!document.querySelector("#hubspotScript")) {
        const script = document.createElement("script");
        script.id = "hubspotScript";
        script.src = "//js.hsforms.net/forms/embed/v2.js";
        script.async = true;
        script.onload = () => {
          window.hbspt.forms.create({
            portalId: portalId,
            formId: formId,
            region: region,
            target: "#hubspotForm",
          });
        };
        document.body.appendChild(script);
      } else {
        // Script already loaded, create form
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: portalId,
            formId: formId,
            region: region,
            target: "#hubspotForm",
          });
        }
      }
    };

    if (typeof window !== "undefined") {
      loadScript();
    }
  }, [portalId, formId, region]);

  return <div id="hubspotForm"></div>;
};

export default HubSpotForm;
